import { SVButton } from '@/components/core';
import MoveFundsButton from '@/components/MoveFundsButton';
import { ROUTES } from '@/constants/routes';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function AdvisorDashboardHeader() {
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));
  const navigate = useNavigate();

  return (
    <Grid container spacing={2} mb={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Typography variant="h4">Capture & Track Deposits</Typography>
      </Grid>
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 2,
          display: 'flex',
          flexDirection: isLargeScreen ? 'row' : 'column',
        }}>
        <SVButton
          onClick={() => navigate(ROUTES.BANK_ACCOUNT_APPLICATIONS)}
          fullWidth={!isLargeScreen}>
          Open New Account
        </SVButton>
        <MoveFundsButton isFullWidth={!isLargeScreen} />
      </Grid>
    </Grid>
  );
}
